import Collapse from '@material-ui/core/Collapse';
import MyIcon from 'components/Icon';
import React, { Component } from 'react';
import './index.css';

interface IProps {
  contentActive?: boolean;
  icon?: any;
  title?: string;
  arrow?: boolean;
  className?: string;
  onClick?: any;
  noPadding?: boolean;
  disabled?: boolean;
}

interface IStates {
  expanded: boolean;
}

class MyCollapse extends Component<IProps, IStates> {
  ref: any = React.createRef();
  constructor(props: IProps) {
    super(props);
    this.state = { expanded: this.props.contentActive };
    this.handleExpandClick = this.handleExpandClick.bind(this);
  }
  handleExpandClick(callback: any) {
    this.setState({ expanded: !this.state.expanded }, () => {
      if (callback) {
        callback(this.state.expanded, this.ref);
      }
    });
  }
  getRef = (e: any) => (this.ref = e);
  expand = () => this.handleExpandClick(this.props.onClick);
  render() {
    return (
      <div
        id={this.props.title}
        ref={this.getRef}
        className={
          'my-collapse ' +
          (this.state.expanded ? '--active ' : '') +
          (this.props.disabled ? '--disabled ' : '') +
          (this.props.className ? this.props.className : '')
        }
      >
        <div className='my-collapse__title' onClick={this.expand}>
          {this.props.icon && <span className='my-collapse__icon'>{this.props.icon}</span>}

          {this.props.title}

          {this.props.arrow && (
            <span className='my-collapse__arrow'>
              <MyIcon name='arrow-collapse' />
            </span>
          )}
        </div>

        <div className={this.props.noPadding ? 'my-collapse__content -nopadding' : 'my-collapse__content'}>
          <Collapse in={this.state.expanded} timeout='auto'>
            {this.props.children}
          </Collapse>
        </div>
      </div>
    );
  }
}
export default MyCollapse;
